module.exports = __webpack_public_path__ + "media/components/resources/show/resource-show-native-ad/img/version3-6785538f161e1283be60f1a654d8c0d8.jpg";